export default (() => ({
  bodyText: {
    margin: '40px 0',
  },
}));
